module.exports = __webpack_public_path__ + "static/img/newskk.5c7e102.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/newskk.png
// module id = POVM
// module chunks = 45